import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/api/http/client'
import { queryKeys } from '@/api/query-keys'

async function deactivateSensemaker(tenantId: string): Promise<void> {
  await apiClient.patch(`/api/v1/platform/sensemakers/${encodeURIComponent(tenantId)}/deactivate`)
}

async function reactivateSensemaker(tenantId: string): Promise<void> {
  await apiClient.patch(`/api/v1/platform/sensemakers/${encodeURIComponent(tenantId)}/reactivate`)
}

export function useDeactivateSensemaker() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: deactivateSensemaker,
    onSuccess: (_data, tenantId) => {
      void qc.invalidateQueries({ queryKey: queryKeys.tenants.all() })
      void qc.invalidateQueries({ queryKey: queryKeys.tenants.detail(tenantId) })
    },
  })
}

export function useReactivateSensemaker() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: reactivateSensemaker,
    onSuccess: (_data, tenantId) => {
      void qc.invalidateQueries({ queryKey: queryKeys.tenants.all() })
      void qc.invalidateQueries({ queryKey: queryKeys.tenants.detail(tenantId) })
    },
  })
}
